import { render, staticRenderFns } from "./DepartmentView.vue?vue&type=template&id=14beb2ee&scoped=true&"
import script from "./DepartmentView.vue?vue&type=script&lang=js&"
export * from "./DepartmentView.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentView.vue?vue&type=style&index=0&id=14beb2ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14beb2ee",
  null
  
)

export default component.exports